module.exports = __webpack_public_path__ + "img/footer-map.abc543e9.jpg";